const COLORS = {
  POPPY: "#E94B2F",
  OAT: "#FBF7EC",
  BLACK: "#0b0f0e",
  WHITE: "#FFFFFF",
};

export default COLORS;
